import React, { useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { gallerySlides } from '../data/gallery';
export function ProductGallery() {
  const [[index, direction], setState] = useState<[number, number]>([0, 0]);
  const reduceMotion = useReducedMotion();
  const total = gallerySlides.length;
  const slide = gallerySlides[index];
  const goTo = (next: number, dir: number) => {
    setState([(next + total) % total, dir]);
  };
  const offset = reduceMotion ? 0 : 40;
  return <section className="py-20 px-4 bg-stone-100 border-y border-stone-200" aria-roledescription="carousel" aria-label="Inside Makeup Instructor Ready" data-id="element-220" data-mp="3mjh6awc77d4">
      <div className="max-w-5xl mx-auto" data-id="element-221" data-mp="7oegj9upjao9">
        <div className="text-center mb-10" data-id="element-222" data-mp="3pt7yrfuxdvn7">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-stone-800" data-id="element-223" data-mp="3pu9majt4oalt">
            See Inside Makeup Instructor Ready
          </h2>
          <p className="text-rose-800 text-sm md:text-base" data-id="element-224" data-mp="34piusw2r4s01">
            Explore the complete 6-in-1 visual teaching system.
          </p>
        </div>

        <div className="relative max-w-lg mx-auto" data-id="element-225" data-mp="2zqejnzw9ok72">
          <div className="relative aspect-[4/5] bg-white border border-stone-200 rounded-2xl overflow-hidden shadow-xl shadow-rose-900/10" data-id="element-226" data-mp="3dqz1otucybzi">
            <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-227" data-mp="38rvzri9oclvr">
              <motion.img key={slide.src} src={slide.src} alt={slide.alt} custom={direction} initial={{
              opacity: 0,
              x: direction * offset
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction * -offset
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="absolute inset-0 w-full h-full object-contain" data-id="element-228" data-mp="2l2l3aczcxdnf" />
            </AnimatePresence>
          </div>

          <button type="button" onClick={() => goTo(index - 1, -1)} aria-label="Previous image" className="absolute left-2 md:-left-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white border border-stone-200 text-rose-800 shadow-md flex items-center justify-center hover:bg-stone-50 transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-700" data-id="element-229" data-mp="1xacxpt7tyoys">
            <ChevronLeft size={22} aria-hidden="true" data-id="element-230" data-mp="3eh5kel2fgfu8" />
          </button>
          <button type="button" onClick={() => goTo(index + 1, 1)} aria-label="Next image" className="absolute right-2 md:-right-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white border border-stone-200 text-rose-800 shadow-md flex items-center justify-center hover:bg-stone-50 transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-700" data-id="element-231" data-mp="3jdw2tf1pfnit">
            <ChevronRight size={22} aria-hidden="true" data-id="element-232" data-mp="2s75uwh1oz6hw" />
          </button>
        </div>

        <p className="sr-only" aria-live="polite" data-id="element-233" data-mp="2s90796ywdqad">
          Image {index + 1} of {total}: {slide.alt}
        </p>

        <div className="mt-6 flex justify-center gap-2 sm:gap-3" data-id="element-234" data-mp="2jelt57q3slsu">
          {gallerySlides.map((s, i) => <button key={s.src} type="button" onClick={() => goTo(i, i > index ? 1 : -1)} aria-label={`Show image ${i + 1}`} aria-current={i === index} className={`w-12 h-16 sm:w-16 sm:h-20 rounded-lg overflow-hidden border-2 bg-white transition-[border-color,opacity] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-700 focus-visible:ring-offset-2 focus-visible:ring-offset-stone-100 ${i === index ? 'border-rose-700 opacity-100' : 'border-stone-200 opacity-60 hover:opacity-100'}`} data-id="element-235" data-mp="2egajoy3q0db5" data-mpi={i}>
              <img src={s.src} alt="" className="w-full h-full object-cover object-top" data-id="element-236" data-mp="3pw8xtgdr9pj8" />
            </button>)}
        </div>
      </div>
    </section>;
}